module.exports = __webpack_public_path__ + "static/media/WSEFFLUENT.dd04eb8d.jpg";